import { MathV } from "../../../../math/MathV";
import { MathX } from "../../../../math/MathX";
import { LomaFunction } from "../LomaFunction";
import { LomaVariable } from "../LomaVariable";

export class Rounding
{
  static functions:LomaFunction[] =
  [
    
    LomaFunction.forNumberIO( "round", "value", ( value ) => Math.round( value )    
    ).setInfo( { en: "Rounds the value to the closest integer" }),

    LomaFunction.forNumberIO( "ceil", "value", ( value ) => Math.ceil( value )    
    ).setInfo( { en: "Rounds up the value to the next bigger integer" }),
    
    LomaFunction.forNumberIO( "floor", "value", ( value ) => Math.floor( value )    
    ).setInfo( { en: "Rounds down the value to the next smaller integer" }),
  ]   
  
}